
































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { MatchHSAndGSRPContent } from "@/models/content/match-hs-and-gsrp";
import CommonMixin, {
  WORKFLOW_PREFERRED_HEAD_START_AND_GREAT_START,
} from "@/mixins/common-mixins";
import { AppData } from "@/models/app-data";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {
    FooterButton,
    PageLoader
  },
})
export default class MatchHSAndGSRP extends Mixins(CommonMixin) {
  content: MatchHSAndGSRPContent = {} as MatchHSAndGSRPContent;
  appData = {} as AppData;
  loadDataFinished = false;
  textDirection = 'ltr'

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getMatchHSAndGSRPContent();
      this.textDirection = contentService.TextDirection()

      this.appData = this.getAppData();
      if (this.appData != null) {
        this.appData.preferredProgram = WORKFLOW_PREFERRED_HEAD_START_AND_GREAT_START;
        this.saveAppData(this.appData);

        await this.putWorkflowStep( this.appData.workflowId, "MatchHSAndGSRP") 
        await this.postWorkflowEligible(
          this.appData.workflowId,
          this.appData.preferredProgram
        );

      }
      this.loadDataFinished = true;
    } catch (error) {
      this.showError(error);
    }
  }

  public handleNextPageEvent(): void {
    this.appData.applyHeadStart = true;
    this.appData.applyGreatStart = true;
    this.saveAppData(this.appData);
    this.$router.push({ path: "GSRPPickPrograms" });
  }

  disableNext(): boolean {
    return !this.loadDataFinished;
  }
}
